import React from 'react'
import pechat from '../../../../Assets/Images/shutterstock_105434768_1-removebg-preview.png'
import qualityImg from '../../../../Assets/Images/download1.png'
import "./Quality.css";

export default function Quality() {
    return (
        <div className='quality'>
            <div className="container">
                <div className="quality-box">
                    <h3 className="quality-title">
                        A Commitment
                        to serve <span className='quality-active'> Quality.</span>
                    </h3>
                    <p className="quality-text">
                        “We are Manufacturer of Quality Agri grains &
                        commodities and private Labels with world class
                        infrastructure and technology with most hygienic
                        and certified environment with organic
                        qualifications.”
                        Come meet us & We’ll Take you to another level !
                    </p>
                    <a href='#' className="quality-link">learn more</a>
                </div>
                <img src={qualityImg} alt="" className="quality-img" />
                <img src={pechat} alt="pechat" className="quality-icon" />
            </div>

        </div>
    )
}
